<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="error-messages">
    <div class='message-error crsr-pntr' (click)='closeErrorMessage();'>
        <span class="message-text" id="message-text">{{message}}</span>
        <span class="error-close-icon fa fa-times" (click)='closeErrorMessage();'></span>
    </div>
</div>